export default __webpack_public_path__ + "static/earned-wage-802184422e64ecda5df366f80b8b6f64.png";